import React, { useState, useEffect } from "react";
import {
  ListGroup,
  ListGroupItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Row,
} from "reactstrap";
import PropTypes from "prop-types";

import { getAccountType } from "../types";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalSignature from "../../Modal/ModalSignature";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";
import Groups from "../../../Asset/Tabs/Groups/Groups";

const SignatureSetsTab = ({
  signatureSets,
  accountId,
  setAccountData,
  holders,
  services,
  mode,
  references,
  groups,
  isReadOnly,
  bankAccounts,
}) => {
  const [fetching, setFetching] = useState(false);
  const [toggleOpen, setToggleOpen] = useState([]);
  const [modalSignature, setModalSignature] = useState({ open: false, signature: undefined });
  const [modalConfirm, setModalConfirm] = useState({ open: false, title: "", callback: undefined });
  const [saving, setSaving] = useState(false);

  const toggleModalNewSignature = (index) => {
    setModalSignature({
      open: !modalSignature.open,
      signature: signatureSets[index],
    });
  };

  const handleRefreshStore = (set) => {
    const initialSets = signatureSets || [];
    let index = -1;
    initialSets.forEach((sigset, i) => {
      if (sigset.SignatureSetId === set.SignatureSetId) {
        index = i;
      }
    });
    if (index >= 0) {
      if (set.SignatureSetWayOfAction === "NoAction") {
        initialSets.splice(index, 1);
      } else {
        initialSets[index] = set;
      }
    } else {
      initialSets.push(set);
    }
    setAccountData({ AccountId: accountId, SignatureSets: initialSets }, true);
  };

  const fetchPostSet = (set) => {
    setSaving(true);
    if (mode !== AccountMode.New) {
      services.fetchAccountUpdate(
        {
          account: {
            AccountId: accountId,
            SignatureSets: [set],
          },
          accountChangeType: getAccountType.SignatureSets,
        },
        (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newSet = { ...set };
            if (set.SignatureSetId === 0) {
              newSet.SignatureSetId = response.Id;
            }
            handleRefreshStore(newSet);
            setSaving(false);
            if (modalSignature.open) {
              toggleModalNewSignature();
            } else {
              setModalConfirm({ open: false, title: "", callback: undefined });
            }
          } else {
            setSaving(false);
          }
        }
      );
    } else {
      services.fetchNewAccount(
        {
          account: {
            AccountOnboardingId: accountId,
            AccountId: accountId,
            SignatureSets: [set],
          },
          accountChangeType: getAccountType.SignatureSets,
        },
        (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newSet = { ...set };
            if (set.SignatureSetId === 0) {
              newSet.SignatureSetId = response.Id;
            }
            handleRefreshStore(newSet);
            setSaving(false);
            if (modalSignature.open) {
              toggleModalNewSignature();
            } else {
              setModalConfirm({ open: false, title: "", callback: undefined });
            }
          } else {
            setSaving(false);
          }
        }
      );
    }
  };

  const toggleModalConfirm = (callback, title = "") =>
    setModalConfirm({ open: !modalConfirm.open, title, callback });
  const toggleDropdown = (index) => {
    const newToggle = toggleOpen.map(() => false);
    newToggle[index] = !toggleOpen[index];
    setToggleOpen(newToggle);
  };

  const handleDeleteSet = (index) => {
    toggleModalConfirm(() => {
      const set = signatureSets[index];
      set.SignatureSetWayOfAction = "NoAction";
      fetchPostSet(set);
    }, "Are you sure you want to delete this signature Set?");
  };

  const handleAddNewSignature = (newSignature) => {
    fetchPostSet(newSignature);
  };

  const listMenuItems = [
    {
      text: (
        <div>
          <i className="fa fa-edit" />
          Edit this Set
        </div>
      ),
      action: toggleModalNewSignature,
    },
    {
      text: (
        <div>
          <i className="fa fa-trash" />
          Remove this Set
        </div>
      ),
      action: handleDeleteSet,
    },
  ];

  useEffect(() => {
    if (mode !== AccountMode.New) {
      if (!signatureSets && !fetching) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataType: getAccountType.SignatureSets,
          },
        };
        services.fetchAccountSectorInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                SignatureSets: response.SDTAccount.SignatureSets,
                BankAccounts: bankAccounts,
                PersonalReferences: references,
                Groups: groups,
              },
              false
            );
          }
          let toggleDWOpen = [];
          if (response && response.SDTAccount) {
            toggleDWOpen = response.SDTAccount.SignatureSets.map(() => false);
          }
          setToggleOpen(toggleDWOpen);
          setFetching(false);
        });
        setFetching(true);
      }
    }
  }, [signatureSets, fetching, accountId, setAccountData, services]);

  useEffect(() => {
    if (mode === AccountMode.New) {
      if (!fetching) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataOnboardingId: accountId,
            GetAccountDataType: getAccountType.SignatureSets,
          },
        };
        services.fetchNewAccountInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                SignatureSets: response.SDTAccount.SignatureSets,
              },
              false
            );
          }
          let toggleDWOpen = [];
          if (response && response.SDTAccount) {
            toggleDWOpen = response.SDTAccount.SignatureSets.map(() => false);
          }
          setToggleOpen(toggleDWOpen);
          setFetching(false);
        });
        setFetching(true);
      }
    }
  }, []);

  return (
    <div>
      {!fetching ? (
        <React.Fragment>
          {signatureSets &&
            signatureSets.map((signature, index) => (
              <ListGroup key={signature.SignatureSetId} style={{ marginBottom: 10 }}>
                <ListGroupItem>
                  {!isReadOnly && (
                    <div style={{ float: "left", marginRight: 10, cursor: "pointer" }}>
                      <ListOptionsDropdown
                        isOpen={toggleOpen[index]}
                        toggle={() => toggleDropdown(index)}
                        items={listMenuItems}
                        index={index}
                      />
                    </div>
                  )}
                  {"  "}
                  {signature.SignatureSetPersonName}
                  {": "}
                  {signature.SignatureSetWayOfAction}
                </ListGroupItem>
                {signature.SignaturePeopleSelected.length > 0 &&
                  signature.SignaturePeopleSelected.map((person) => (
                    <ListGroupItem key={person.SignatureSetPersonId}>
                      {person.SignaturePersonName}
                    </ListGroupItem>
                  ))}
              </ListGroup>
            ))}
          <Row>
            {!isReadOnly && (
              <Button style={{ marginLeft: 10 }} color="primary" onClick={toggleModalNewSignature}>
                Add new Signature Set
              </Button>
            )}
          </Row>
        </React.Fragment>
      ) : (
        <CircularProgress sm />
      )}
      <ModalConfirm toggle={toggleModalConfirm} {...modalConfirm} saving={saving} />
      {modalSignature.open && (
        <ModalSignature
          newSetId={0}
          signature={modalSignature.signature}
          holders={holders}
          onSave={handleAddNewSignature}
          toggle={toggleModalNewSignature}
          open={modalSignature.open}
          saving={saving}
        />
      )}
    </div>
  );
};

function ListOptionsDropdown({ isOpen, toggle, items, index }) {
  return (
    <Dropdown isOpen={isOpen} toggle={toggle}>
      <DropdownToggle tag="a" onClick={toggle} style={{ width: 10, cursor: "pointer" }}>
        <i className="fa fa-ellipsis-v" />
      </DropdownToggle>
      <DropdownMenu>
        {items.length > 0 &&
          items.map((item, i) => (
            <DropdownItem key={i} onClick={() => item.action(index)}>
              {item.text}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
}

ListOptionsDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  index: PropTypes.any.isRequired,
};

SignatureSetsTab.propTypes = {
  signatureSets: PropTypes.array.isRequired,
  accountId: PropTypes.any.isRequired,
  setAccountData: PropTypes.func.isRequired,
  holders: PropTypes.array.isRequired,
  services: PropTypes.object.isRequired,
};

export default SignatureSetsTab;
